exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectable-result[data-v-290694b5] {\n  cursor: pointer;\n}\n.selectable-result[data-v-290694b5]:hover {\n  background: #eaf1fd;\n}\n.selectable-result .selectable-result-avatar[data-v-290694b5] {\n  height: 25px;\n  width: 25px;\n}\n.selectable-result.is-active[data-v-290694b5] {\n  background-color: #1890ff;\n}\n.selectable-result.is-active .ant-list-item-meta-title span[data-v-290694b5] {\n  color: white;\n}\n.selectable-result.is-active .selectable-result-avatar[data-v-290694b5] {\n  border: solid 2px white;\n}\n", ""]);

// exports
